<script lang="ts" setup>
const { t } = useI18n();
useHead({
  title: t("seo.cancellationRequest.title"),
  meta: [
    {
      name: "description",
      content: t("seo.cancellationRequest.meta.description"),
    },
    {
      name: "keywords",
      content: t("seo.cancellationRequest.meta.keys"),
    },
    {
      property: "og:title",
      content: t("seo.cancellationRequest.meta.ogTitle"),
    },
    {
      property: "og:description",
      content: t("seo.cancellationRequest.meta.description"),
    },

    {
      property: "og:url",
      content: "https://www.tutassur.com/contactez-nous",
    },
  ],
});
</script>
<template>
  <div>
    <CancellationRequestSection1 />
    <CancellationRequestSection2 />
  </div>
</template>
